<template>
    <div>
        <el-row v-for="(item, index) in auditorList" :key="item.id">
            <el-form :model="examineDetailsList[index]" :rules="rules" ref="ruleForm">
                <el-divider content-position="left">
                    <el-checkbox :indeterminate="isIndeterminate[index]" v-model="checkAll[index]"
                        @change="handleCheckAllChange(index)">
                        {{"节点" + (item.node + 1)}}
                    </el-checkbox>
                </el-divider>
                <el-form-item prop="staff_check">
                    <el-checkbox-group v-model="examineDetailsList[index].staff_check"
                        @change="handleCheckedCitiesChange(index)">
                        <el-checkbox v-for="item1 in item.staffList" :label="item1.id" :key="item1.id">
                            {{item1.staff_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row style="margin-top: 10px; text-align: center;">
            <el-button type="goon" @click="Add" v-show="id == null || id == ''">保存
            </el-button>
            <el-button type="goon" @click="Update" v-show="id != null && id != ''">修改
            </el-button>
        </el-row>
    </div>
</template>

<script>
    export default {
        props: ["type", "examineDetailsList", "id"],
        data() {
            return {
                //审核人
                auditorList: [],

                //全选按钮
                checkAll: [],
                //不确定状态
                isIndeterminate: [],

                details: [],

                //表单验证
                rules: {
                    staff_check: [{
                        required: true,
                        message: '请选择审批人！',
                        trigger: 'blur'
                    }],
                },

            }
        },
        methods: {
            handleCheckAllChange(index) {
                this.$props.examineDetailsList[index].staff_check = [];
                this.isIndeterminate[index] = false;
                if (this.checkAll[index]) {
                    this.auditorList[index].staffList.forEach(item => {
                        this.$props.examineDetailsList[index].staff_check.push(item.id)
                    })
                }
            },
            handleCheckedCitiesChange(index) {
                this.checkAll[index] = false;
                if (this.$props.examineDetailsList[index].staff_check.length == this.auditorList[index].staffList
                    .length) {
                    this.checkAll[index] = true;
                    this.isIndeterminate[index] = false;
                }
                if (this.$props.examineDetailsList[index].staff_check.length == 0) {
                    this.isIndeterminate[index] = false;
                }
                this.$forceUpdate();
            },
            Add() {
                var flag = false;
                this.$refs["ruleForm"].forEach(item => {
                    item.validate((valid) => {
                        flag = valid;
                    });
                })
                if (flag) {
                    this.$props.examineDetailsList.forEach(item => {
                        item.staff_check.forEach(staff_id => {
                            item.staff_ids += "," + staff_id
                        })
                    })
                    this.$parent.$parent.Add();
                }
            },
            Update() {
                var flag = false;
                this.$refs["ruleForm"].forEach(item => {
                    item.validate((valid) => {
                        flag = valid;
                    });
                })
                if (flag) {
                    this.$props.examineDetailsList.forEach(item => {
                        item.staff_check.forEach(staff_id => {
                            item.staff_ids += "," + staff_id
                        })
                    })
                    
                    this.$parent.$parent.Update();
                }
            },
            async initialize() {
                this.checkAll = [];
                this.isIndeterminate = [];
                if (this.$props.id != '' && this.$props.id != null && this.$props.type != '13') {
                    //查询审批流详情
                    var details = await this.$globals.AxiosPost("examine/selectByExamineIdKey", {
                        examine_id: this.$props.id,
                        examine_type: this.$props.type
                    });
                    this.details = details.data;
                } else {
                    this.details = null;
                }

                //查询审批流审批人
                var auditorList = await this.$globals.AxiosPost("flow/selectAuditor", {
                    type: this.$props.type,
                    state: "1"
                });
                this.auditorList = auditorList.data.sysFlowDetails;

                //修改情况
                if (this.details != null && this.details != undefined) {
                    //复选框回显
                    this.details.examineDetailsList.forEach((item, index) => {
                        this.checkAll.push(false);
                        this.isIndeterminate.push(false);
                        var staff_check = [];

                        item.staff_ids.split(",").forEach((staff_id, index) => {
                            if (staff_id != null && staff_id != undefined && staff_id != "") {
                                if (staff_check.length <= 0) {
                                    staff_check.push(parseInt(staff_id));
                                } else {
                                    var flag = true;
                                    staff_check.some(staff_id_check => {
                                        if(staff_id_check == parseInt(staff_id)){
                                            flag = false;
                                            return true;
                                        }
                                    })
                                    if(flag){
                                        staff_check.push(parseInt(staff_id));
                                    }
                                }
                            }
                        })
                        this.$props.examineDetailsList.push({
                            examine_id: "",
                            node: item.node,
                            staff_ids: item.staff_ids,
                            staff_check: staff_check
                        })
                        this.handleCheckedCitiesChange(index);
                    })

                } else {
                    //添加情况
                    this.auditorList.forEach(item => {
                        this.checkAll.push(false);
                        this.isIndeterminate.push(false);
                        this.$props.examineDetailsList.push({
                            examine_id: "",
                            node: item.node,
                            staff_ids: "",
                            staff_check: []
                        })
                    })
                }
            }
        },
        created() {
            this.initialize();
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// SelectAuditor.vue?bc9f4cd4